import { phoneNumberFormatter } from '@exam-center/utils';
import { Flex, Grid, ReadonlyField, SectionTitle, Text } from '@shared/components';

export interface PersonalInformationReadOnlyFieldsProps {
  idNumber: string;
  title: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  email: string | null;
  phoneNumber: string | null;
}

export default function PersonalInformationReadOnlyFields(
  props: Readonly<PersonalInformationReadOnlyFieldsProps>,
) {
  const { idNumber, title, firstName, middleName, lastName, email, phoneNumber } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        p: theme.spacing(6),
      })}
    >
      <SectionTitle title='Personal Information' />
      <Grid
        sx={(theme) => ({
          gridTemplateColumns: '240px 1fr',
          gap: theme.spacing(6),
        })}
      >
        <Text variant='body1Semibold'>ข้อมูลส่วนตัว</Text>
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(4),
            flexDirection: 'column',
          })}
        >
          <ReadonlyField label='ID / Passport No.' content={idNumber} sx={{ maxWidth: '600px' }} />
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <ReadonlyField
              label='คำนำหน้า'
              sx={{
                maxWidth: '200px',
              }}
              content={title}
            />
            <ReadonlyField label='ชื่อ' content={firstName} />
            <ReadonlyField label='ชื่อกลาง' content={middleName ?? ''} />
            <ReadonlyField label='นามสกุล' content={lastName} />
          </Flex>
        </Flex>
        <Text variant='body1Semibold'>ข้อมูลสำหรับติดต่อ</Text>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(4),
            maxWidth: '600px',
          })}
        >
          <ReadonlyField label='อีเมลผู้ใช้' content={email ?? '-'} />
          <ReadonlyField
            label='เบอร์โทรศัพท์'
            content={phoneNumber ? phoneNumberFormatter(phoneNumber) : '-'}
          />
        </Flex>
      </Grid>
    </Flex>
  );
}
